module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-backdrop-768x591.2cb8c8a8.jpg";